import React, {useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {NewCategory, NewUser, TypeForm, User} from "../types";
import {getError} from "../utils/getError";
import {useLogin} from "../hooks/useAuth";
import "../styles/FormAuth.scss"

export function Login() {
    const [error, setError] = useState<string>("");
    const {mutate: loginUser} = useLogin()
    const [customLoading, setCustomLoading] = useState(false);


    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm<NewUser>()

    const onSubmit: SubmitHandler<NewUser> = async (user: User) => {
        setCustomLoading(true)
        try {
           loginUser(user)
        } catch (error: any) {
            setError(getError(error));
        }
        setCustomLoading(false)
    }

    return (
        <form id="form-login" onSubmit={handleSubmit(onSubmit)}>
            <h1>Connexion</h1>
            <label>Email</label>
            <input type={"email"} {...register("email")} required={true}/>
            <label>Mot de passe</label>
            <input type={"password"}{...register("password")} required={true}/>
            <div className={"errorMessage"}>{error}</div>
            <button type="submit" disabled={customLoading}>Connexion</button>
        </form>
    )
}

